import(/* webpackMode: "eager", webpackExports: ["RouteRestrictionGuard"] */ "/vercel/path0/apps/web/components/auth/RouteRestrictionGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/PageWrapperAppDir.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
